<template>
  <div>
    <slide-y-down-transition>
      <md-icon class="error" v-show="valid === false">close</md-icon>
    </slide-y-down-transition>
    <slide-y-down-transition>
      <md-icon class="success" v-show="valid === true">done</md-icon>
    </slide-y-down-transition>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  name: "ErrorIndicator",

  components: {
    SlideYDownTransition,
  },

  props: {
    valid: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Validation/ErrorIndicator.vue